import { ScheduleViewType } from 'redux-store/api/profile-preference';
import { IProject } from 'redux-store/api/projects';
import {
  IGanttUpdatePhaseItem,
  IMatchingPhase,
  IMatchingPhaseItem,
  IPhase,
  TEventsList,
  TEventsListPoppper,
} from 'redux-store/types';

export enum ItemTypeEnum {
  SCHEDULE_ITEM = 'SCHEDULE_ITEM',
  PHASE = 'PHASE',
}

export enum CalendarViewModeEnum {
  MONTH = 'month',
  WEEK = 'week',
  DAY = 'day',
}

export interface ICalendarView {
  project: IProject;
  tab: ScheduleViewType;
  onChangeTab: (view: ScheduleViewType) => void;
}

export type TCalendarMode = {
  label: string;
  value: CalendarViewModeEnum;
  id: number;
};

export type TCalendarModeScales = TCalendarMode[];

export interface ICalendarModeItemProps {
  mode: TCalendarMode;
  handleChangeScale: (mode: CalendarViewModeEnum) => void;
}

export type TCalendarClickEvent = (
  event: React.MouseEvent,
  setPopperProps: (props: TEventsListPoppper) => void
) => void;

export type THandleShowMoreEvents = (
  date: Date,
  getActualProject: (dayEvents: any) => (IMatchingPhase | IMatchingPhaseItem)[],
  setMoreEventsList: (items: TEventsList) => void,
  getLastClickPosition: () => {
    x: number;
    y: number;
  }
) => void;

export interface IEventListItemProps {
  itemType: ItemTypeEnum;
  title: string;
  color: string;
  id: number;
}

export interface IScheduleModalProps {
  handleAllowUpdateProject?: () => void;
  handleDeleteTask?: (id: string, isPhase?: boolean) => void;
  handleSetScrollingId?: (id: string | number) => void;
  handleAddCalendarTask: (newEvent: ICalendarItem) => void;
  handleUpdateTask?: (taskId: string, task?: IGanttUpdatePhaseItem) => void;
}

export type ICalendarItem = {
  id: string;
  text: string;
  start_date: Date;
  end_date: Date;
  item_type: ItemTypeEnum;
  color?: string;
  parent_title?: string;
  parent_color?: string;
  parent_id: string | number;
  is_loading: boolean;
  original_event_data: string;
};
